import { request } from '@umijs/max';

/** 客户委托接收人规则，所有长整型ID以字符串传递，避免精度损失。 */
export type OurContactRule = {
  /** 规则ID，新增时不传。 */
  id?: string;
  /** 规则所属客户ID。 */
  customerId: string;
  /** 必选业务领域编码。 */
  businessLines: number;
  /** 业务类型；0或空值表示不限。 */
  businessType?: number | null;
  /** 子业务类型ID；0或空值表示不限。 */
  businessSubTypeId?: string | null;
  /** 服务端返回的子业务类型名称，仅用于展示。 */
  businessSubTypeName?: string | null;
  /** 该场景唯一的机构员工用户ID。 */
  userId: string;
};

/** 项目统一响应；请求失败原因由message提供。 */
type RuleResponse<T> = {
  /** 本次业务请求是否成功。 */
  success: boolean;
  /** 成功时返回的规则或规则ID。 */
  result: T;
  /** 服务端可展示的失败原因。 */
  message?: string;
};

/** 查询客户的独立联系人规则；无配置时返回空数组。 */
export const listOurContactRules = (customerId: string) =>
  request<RuleResponse<OurContactRule[]>>('/admin/customer/ourContactRule/list', { params: { customerId } });

/** 独立保存一条规则，成功后仅影响新委托。 */
export const saveOurContactRule = (data: OurContactRule) =>
  request<RuleResponse<string>>('/admin/customer/ourContactRule/upsert', { method: 'POST', data });

/** 删除所属客户下的规则，不变更已有委托接收人。 */
export const deleteOurContactRule = (customerId: string, id: string) =>
  request<RuleResponse<void>>('/admin/customer/ourContactRule/delete', { method: 'POST', data: { customerId, id } });

/** 按客户隔离事务的批量设置结果，计数单位为规则行。 */
export type OurContactRuleBatchResult = {
  /** 成功新增或更新的规则行数。 */
  successCount: number;
  /** 校验失败或同客户连带回滚的行数。 */
  failedCount: number;
  /** 失败输入和可向用户展示的原因。 */
  failedItems: {
    /** 未能提交的原始场景输入。 */
    item: OurContactRule;
    /** 该客户校验失败或整体回滚的原因。 */
    reason: string;
  }[];
};

/** 按客户及三级条件批量更新或新增，不携带规则ID，仅影响新委托。 */
export const batchSaveOurContactRules = (items: OurContactRule[]) =>
  request<RuleResponse<OurContactRuleBatchResult>>(
    '/admin/customer/ourContactRule/batch',
    {
      method: 'POST',
      data: { items },
    },
  );
